import { ChaveValor } from "../chave-valor.model"

export class TipoLogradouro {
    lista: ChaveValor[];

    constructor() {
        this.lista = [
            { id: 0, nome: 'AVENIDA', label: 'Avenida' },
            { id: 1, nome: 'RUA', label: 'Rua' },
            { id: 2, nome: 'TRAVESSA', label: 'Travessa' },
            { id: 3, nome: 'QUADRA', label: 'Quadra' },
            { id: 4, nome: 'PRACA', label: 'Praça' },
            { id: 5, nome: 'VILA', label: 'Vila' },
            { id: 6, nome: 'ALAMEDA', label: 'Alameda' },
            { id: 7, nome: 'ESTRADA', label: 'Estrada' },
            { id: 8, nome: 'RODOVIA', label: 'Rodovia' },
            { id: 9, nome: 'OUTRO', label: 'Outro' },
            { id: 10, nome: 'VIADUTO', label: 'Viaduto' },
            { id: 11, nome: 'SITIO', label: 'Sítio' },
            { id: 12, nome: 'LOTEAMENTO', label: 'Loteamento' },
            { id: 13, nome: 'FAZENDA', label: 'Fazenda' },
            { id: 14, nome: 'DISTRITO', label: 'Distrito' },
            { id: 15, nome: 'CHACARA', label: 'Chácara' },
            { id: 16, nome: 'MORRO', label: 'Morro' },
            { id: 17, nome: 'PARQUE', label: 'Parque' }
        ];
    }
}
